import React from 'react';

import Spinner from '../Spinner';

import './styles.scss';

interface IProps {
    loading: boolean;
    children: any
}

const InputSpinner = ({ loading, children }: IProps) => {
    return (
        <div id="InputSpinner">
            {children}
            {loading && <Spinner />}
        </div>
    );
};

export default InputSpinner;